
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface CustomerSearchProps {
  searchTerm: string;
  onChange: (value: string) => void;
}

export function CustomerSearch({ searchTerm, onChange }: CustomerSearchProps) {
  return (
    <div className="relative w-full md:w-auto md:min-w-[300px]">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
      <Input
        type="search"
        placeholder="Buscar cliente..."
        className="pl-8"
        value={searchTerm}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
